<script>
import Layout from "./Layout.vue";
import Loading from "./Loading.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "EffectiveContractApp",
  components: {Loading, Layout},

  data() {
    return {
      loading: true,
    }
  },

  async mounted() {
    try {
      await this.getDataEmployee();
      await this.getEffConOrder();
    } catch(err) {
      console.log(err)
    } finally {
      this.loading = false;
    }
  },

  methods: {
    ...mapActions({
      getDataEmployee: "effective_contract/getDataEmployee",
      getEffConOrder: "effective_contract/getEffConOrder"
    }),
  }
}
</script>

<template>
  <v-app>
    <v-main>
      <loading :loading="loading">
        <Layout/>
      </loading>
    </v-main>
  </v-app>
</template>

<style scoped>

</style>